import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { flagsFromSession } from '@wix/da-react-context/pkg/flags/helpers';
export const initFlags = createAction(`${actionKey}.INIT_FLAGS`, ({ features })=>({
        flags: flagsFromSession(features)
    }));
export const setFlags = createAction(`${actionKey}.SET_FLAGS`, (flags)=>({
        flags
    }));
